import { motion } from "framer-motion";
import { HelpCircle } from "lucide-react";

const faqs = [
    {
        q: "هل تبرمجون مفاتيح جميع ماركات السيارات؟",
        a: "نعم، نبرمج ونشفّر المفاتيح الذكية والريموتات لجميع الماركات، ونصنع مفتاحاً جديداً كاملاً حتى لو ضاع آخر مفتاح.",
    },
    {
        q: "هل يمكنكم فتح باب الشقة المقفل دون تلف؟",
        a: "نعم، نفتح أقفال الشقق والفلل والمحلات بأدوات احترافية بدون خدش أو كسر.",
    },
    {
        q: "ما مناطق الخدمة داخل جدة؟",
        a: "نخدم جميع أحياء جدة بخدمة متنقلة تصل إلى موقعك.",
    },
    {
        q: "هل الخدمة متاحة في الليل؟",
        a: "نعم، الخدمة متاحة 24 ساعة طوال أيام الأسبوع.",
    },
];

const FAQ = () => (
    <section id="faq" data-testid="faq-section" className="relative py-24 sm:py-32">
        <div className="mx-auto max-w-4xl px-4 sm:px-6">
            <motion.div
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.7 }}
                className="mb-12"
            >
                <p className="mb-3 text-xs font-bold uppercase tracking-[0.25em] text-amber-500">
                    الأسئلة الشائعة
                </p>
                <h2 className="font-display text-3xl font-black text-white sm:text-4xl">
                    إجابات سريعة قبل ما تتصل
                </h2>
            </motion.div>

            <div className="grid gap-4">
                {faqs.map((f, i) => (
                    <motion.article
                        key={i}
                        initial={{ opacity: 0, y: 22 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, margin: "-40px" }}
                        transition={{ duration: 0.55, delay: i * 0.08 }}
                        data-testid={`faq-item-${i}`}
                        className="service-card rounded-3xl border border-[#232F45] bg-[#151C2A] p-6 sm:p-7"
                    >
                        <h3 className="mb-2 flex items-center gap-3 text-lg font-extrabold text-white">
                            <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-amber-500/12 text-amber-400">
                                <HelpCircle size={18} />
                            </span>
                            {f.q}
                        </h3>
                        <p className="pr-12 text-sm leading-relaxed text-gray-400 sm:text-base">
                            {f.a}
                        </p>
                    </motion.article>
                ))}
            </div>
        </div>
    </section>
);

export default FAQ;
